/**
 * packsのエントリポイント
 * Railsのviewの命名に合わせて作る
 * jsとcssのimport以外はなるべく他のファイルに書く
 */
import 'stylesheets/pages/inquiries/new';
import InquiriesForm from 'modules/InquiriesForm';

document.addEventListener('DOMContentLoaded', () => {
  new InquiriesForm(document.getElementById('Inquiries-Form'));
});
